import { Repository } from 'core/repositories/Repository';
import { httpConfig } from 'config/http';
import { url } from 'core/helpers/string';
import { API_BASE_URL } from 'core/config';
import { API_LICENSE_INFORMATION_ROUTE } from 'config/api-consts';
import kebabCase from 'lodash/kebabCase';
import nameof from 'ts-nameof.macro';
import { AxiosResponse } from 'axios';

export class LicenseInformationRepository extends Repository {
  constructor() {
    super(httpConfig);
    this.setBaseURL(url(API_BASE_URL, API_LICENSE_INFORMATION_ROUTE));
  }

  public get = async (): Promise<any> => {
    return this.http
      .post<any>(kebabCase(nameof(this.get)))
      .then((response: AxiosResponse<any>) => {
        return response.data;
      });
  };

  public import = (file: File, name: string = nameof(file)): Promise<void> => {
    const formData: FormData = new FormData();
    formData.append(name, file);
    return this.http
      .post<void>(kebabCase(nameof(this.import)), formData, {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
      })
      .then((response: AxiosResponse<void>) => response.data);
  };
}

const licenseInformationRepository = new LicenseInformationRepository();
export default licenseInformationRepository;
